import { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { Box, Button, colors, Typography } from "@mui/material";
import { useMobileContext } from "context/mobile/mobileContext";
import { useUserContext } from "context/data/userContext";
import ProductPreview from "components/ProductPreview/ProductPreview";
import { onPrint } from "hooks/onPrint";
import { iconHutBotHappy } from "images";
import { useIntl } from "react-intl";
import { DefaultTheme } from "@byte-coach/admin-ui-components";

export function SuccessPage() {
  const { brand, country, cart, setCart, dateTime, pic } = useMobileContext();
  const { user } = useUserContext();
  const intl = useIntl();
  const navigate = useNavigate();
  const currentStore = useMemo(() => { return (window.mapp as any)?.userInfo?.currentStore }, []);

  return (
    <>
      <Box sx={{ textAlign: 'center', marginBottom: '10px' }}>
        <Typography
          sx={{ color: 'black', fontSize: 24, marginBottom: '10px' }}>
          {intl.formatMessage({ id: 'mobile.heading.success' })}
        </Typography>
        <img alt={'Happy HutBot Icon'} src={iconHutBotHappy} />
      </Box>
      <Box>
        {cart.map((product, index) => (
          <Box sx={{
            borderTop: index !== 0 ? `1px solid ${colors.grey[200]}` : '0px'
          }}>
            <ProductPreview
              {...product}
              dateTime={dateTime as Date}
            />
          </Box>
        ))}
      </Box>
      <Box sx={{ flex: 1 }}></Box>
      <Box sx={{ display: 'flex' }}>
        <Box sx={{ marginTop: '60px' }} />
        <Box sx={{ bottom: 0, left: 0, right: 0, position: 'fixed', display: 'flex', padding: '16px', backgroundColor: DefaultTheme.palette.secondary.light }}>
          <Button
            variant="outlined"
            onClick={() => onPrint({ cart, intl, brand, country, pic, user, isReprint: true, currentStore })}
            sx={{ flex: 1, marginRight: '12px'}}>
            {intl.formatMessage({ id: 'mobile.button.reOrder.title' })}
          </Button>
          <Button variant="contained" onClick={() => {
            setCart([]);
            navigate('../');
          }}>{intl.formatMessage({ id: 'mobile.button.goHome.title' })}</Button>
        </Box>
      </Box>
    </>
  );
}
